export default "__VITE_ASSET__0e41b315__"